<template>
  <div class="hk-video">
    <div
      :id="'playWind' + videoId"
      :style="{ width: VWidth + 'px', height: VHeight - 30 + 'px' }"
    ></div>
    <div class="button_box flex-space-between">
      <div>
        <span @click="stopPlay" v-if="playState"
          ><img src="@/assets/images/hk-video/play-o.png" alt=""
        /></span>
        <span @click="realplay()" v-else
          ><img src="@/assets/images/hk-video/play-c.png" alt=""
        /></span>
        <!-- <span v-show="!playBackState">
          <span @click="talkStop()" v-if="intercomState"
            ><img src="@/assets/images/hk-video/intercom-o.png" alt=""
          /></span>
          <span @click="talkStart()" v-else
            ><img src="@/assets/images/hk-video/intercom-c.png" alt=""
          /></span>
        </span> -->
        <span @click="capture()" v-if="!playState"
          ><img src="@/assets/images/hk-video/screenshot.png" alt=""
        /></span>
        <span v-show="!playBackState">
          <span @click="closeSound()" v-if="audioState"
            ><img src="@/assets/images/hk-video/audio-o.png" alt=""
          /></span>
          <span @click="openSound()" v-else
            ><img src="@/assets/images/hk-video/audio-c.png" alt=""
          /></span>
        </span>
      </div>
      <div>
        <span @click="openTime()" v-if="playBackState"
          ><img src="@/assets/images/hk-video/date.png" alt=""
        /></span>
        <span @click="realplay()" v-if="playBackState"
          ><img src="@/assets/images/hk-video/back.png" alt=""
        /></span>
        <span @click="playbackBtn()" v-else
          ><img src="@/assets/images/hk-video/play-back.png" alt=""
        /></span>
        <span @click="fullSreen()"
          ><img src="@/assets/images/hk-video/full-sreen.png" alt=""
        /></span>
      </div>
      <div class="time-model" v-show="timeModelState">
        <Form :label-width="80">
          <FormItem label="开始时间">
            <DatePicker
              type="datetime"
              placeholder="请输入开始时间"
              style="width: 200px"
              v-model="startTime"
            ></DatePicker>
          </FormItem>
          <FormItem label="结束时间">
            <DatePicker
              type="datetime"
              placeholder="请输入结束时间"
              style="width: 200px"
              v-model="endTime"
            ></DatePicker>
          </FormItem>
          <div class="flex-space-around" style="margin-top: 10px">
            <Button @click="timeBtn(1)">取消</Button>
            <Button
              @click="timeBtn(2)"
              type="primary"
              :disabled="!startTime || !endTime"
              >确定</Button
            >
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import { getDate } from "@/libs/tools";
export default {
  props: {
    VWidth: {
      type: String,
      default: "600",
    },
    VHeight: {
      type: String,
      default: "400",
    },
    previewUrl: {
      type: String,
      default: "",
    },
    videoId: {
      type: Number,
      default: 0,
    },
    channelNum: {
      type: String,
      default: "",
    },
    sid: {
      type: String,
      default: "",
    },
  },
  name: "hk-video",
  data() {
    return {
      iWind: 1,
      mode: 0,
      player: {},
      playUrl: "", //直播地址
      playBackUrl: "", //回放地址
      playTalkUrl: "", //对讲地址
      playState: true, //是否播放 true是 false 否
      intercomState: false, //是否开启语音
      audioState: false, // 是否开启声音 true是 false 否
      playBackState: false, //是否是回放 true是 false 否
      timeModelState: false, //显示选择时间
      startTime: null,
      endTime: null,
    };
  },
  methods: {
    init() {
      // 设置播放容器的宽高并监听窗口大小变化
      window.addEventListener("resize", () => {
        this.player.JS_Resize();
      });
    },
    createPlayer() {
      const IS_MOVE_DEVICE = document.body.clientWidth < 992; // 是否移动设备
      this.player = new window.JSPlugin({
        szId: "playWind" + this.videoId,
        szBasePath: "./static/h5VideoStatic/",
        iMaxSplit: 1,
        iCurrentSplit: IS_MOVE_DEVICE ? 1 : 2,
        openDebug: true,
        oStyle: {
          borderSelect: IS_MOVE_DEVICE ? "#000" : "#FFCC00",
        },
      });
      // 事件回调绑定
      this.player.JS_SetWindowControlCallback({
        windowEventSelect: function (iWndIndex) {
          //插件选中窗口回调
          console.log("windowSelect callback: ", iWndIndex);
        },
        pluginErrorHandler: function (iWndIndex, iErrorCode, oError) {
          //插件错误回调
          console.log("pluginError callback: ", iWndIndex, iErrorCode, oError);
        },
        windowEventOver: function (iWndIndex) {
          //鼠标移过回调
          //console.log(iWndIndex);
        },
        windowEventOut: function (iWndIndex) {
          //鼠标移出回调
          //console.log(iWndIndex);
        },
        windowEventUp: function (iWndIndex) {
          //鼠标mouseup事件回调
          //console.log(iWndIndex);
        },
        windowFullCcreenChange: function (bFull) {
          //全屏切换回调
          console.log("fullScreen callback: ", bFull);
        },
        firstFrameDisplay: function (iWndIndex, iWidth, iHeight) {
          //首帧显示回调
          console.log(
            "firstFrame loaded callback: ",
            iWndIndex,
            iWidth,
            iHeight
          );
        },
        performanceLack: function () {
          //性能不足回调
          console.log("performanceLack callback: ");
        },
      });
      this.realplay();
    },
    //开启直播
    realplay() {
      this.stopPlay();
      if (this.playBackState) {
        this.playBackState = false;
      }
      let { player, playUrl, playBackUrl, iWind, mode } = this;
      var playURL = this.playBackState ? playBackUrl : playUrl;
      console.log("接收视频地址", playURL, iWind);
      player.JS_Play(playURL, { playURL, mode }, iWind).then(
        () => {
          this.playState = true;
          console.log("realplay success");
        },
        (e) => {
          console.error("预览失败++", e);
        }
      );
    },
    // 停止直播
    stopPlay() {
      let { player, iWind } = this;
      this.player.JS_Stop(iWind).then(
        () => {
          this.playState = false;
          console.log("stop realplay success");
        },
        (e) => {
          console.error(e);
        }
      );
    },
    //关闭声音
    closeSound() {
      this.player.JS_CloseSound().then(
        () => {
          console.log("closeSound success");
          this.audioState = false;
        },
        (e) => {
          console.error(e);
        }
      );
    },
    // 开启声音
    openSound() {
      this.player.JS_OpenSound().then(
        () => {
          console.log("openSound success");
          this.audioState = true;
        },
        (e) => {
          console.error(e);
        }
      );
    },
    //获取语音对讲地址
    getTalkUrl() {
      let params = {
        type: "post",
        url: "/mcbw/cameras/hik/stream_media",
        obj: {
          commitData: {
            id: this.channelNum,
            devIndex: this.sid,
            webType: "1",
            streamType: "sub",
            method: "playback",
            startTime: this.startTime
              ? new Date(this.startTime).getTime()
              : null,
            endTime: this.endTime ? new Date(this.endTime).getTime() : null,
          },
        },
      };
      this.$Axios(params)
        .then((res) => {
          if (res.success && res.data) {
            this.playTalkUrl = res.data;
            this.talkStart();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 开启语音对讲
    talkStart() {
      this.player.JS_SetConnectTimeOut(0, 1000);
      this.player.JS_StartTalk(this.playTalkUrl).then(
        () => {
          this.intercomState = true;
          console.log("talkStart success");
        },
        (e) => {
          console.error(e);
        }
      );
    },
    // 关闭语音对讲
    talkStop() {
      this.player.JS_StopTalk().then(
        () => {
          this.intercomState = false;
          console.log("talkStop success");
        },
        (e) => {
          console.error(e);
        }
      );
    },
    //截图
    capture() {
      let { player, iWind } = this;
      player.JS_CapturePicture(iWind, "img", "JPEG").then(
        () => {
          console.log("capture success");
        },
        (e) => {
          console.error(e);
        }
      );
    },
    openTime() {
      // 选择时间
      this.startTime = null;
      this.endTime = null;
      this.timeModelState = true;
    },
    timeBtn(type) {
      this.timeModelState = false;
      if (type === 2) {
        let data = {
          type: "post",
          url: "/mcbw/cameras/hik/stream_media",
          obj: {
            id: this.channelNum,
            devIndex: this.sid,
            webType: "1",
            streamType: "sub",
            method: "playback",
            startTime: this.startTime
              ? new Date(this.startTime).getTime()
              : null,
            endTime: this.endTime ? new Date(this.endTime).getTime() : null,
          },
        };
        this.$Axios(data)
          .then((res) => {
            if (res.data.success && res.data) {
              this.playBackUrl = res.data.data;
              this.playbackV();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.startTime = null;
        this.endTime = null;
      }
    },
    //回放
    playbackBtn() {
      this.stopPlay();
      this.playBackState = true;
    },
    //播放回放
    playbackV() {
      console.log("666666666666666")
      let { player, mode, iWind, playBackUrl } = this;
      console.log(playBackUrl)
      let playURL = playBackUrl.split("?")[0];
      let startTime =
        getDate(new Date(this.startTime).getTime(), "day") +
        "T" +
        getDate(new Date(this.startTime).getTime(), "hoursSecond");
      let endTime =
        getDate(new Date(this.endTime).getTime(), "day") +
        "T" +
        getDate(new Date(this.endTime).getTime(), "hoursSecond");
      startTime += "Z";
      endTime += "Z";
      console.log("时间", playURL, startTime, endTime);
      player
        .JS_Play(playURL, { playURL, mode }, iWind, startTime, endTime)
        .then(
          () => {
            console.log("playbackStart success");
            this.playback.rate = 1;
          },
          (e) => {
            console.error(e);
          }
        );
    },
    //全屏
    fullSreen() {
      this.player.JS_FullScreenDisplay(true).then(
        () => {
          console.log(`wholeFullScreen success`);
        },
        (e) => {
          console.error(e);
        }
      );
    },
  },
  mounted() {
    this.init();
    this.createPlayer();
  },
  created() {
    this.playUrl = this.previewUrl;
  },
  destroyed() {
    this.stopPlay();
  },
};
</script>

<style scoped lang="scss">
.hk-video {
  position: relative;
  margin-top: 30px;
}
.button_box {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  padding: 5px 10px;
  > div {
    display: flex;
    span {
      img {
        width: 18px;
        height: 18px;
      }
    }
    > span {
      margin-left: 10px;
      &:first-child {
        margin-left: 0;
      }
    }
  }
  .ivu-form-item {
    margin-bottom: 5px;
  }
  .time-model {
    position: absolute;
    right: 10px;
    bottom: 40px;
    width: 300px;
    background-color: #cde1fd;
    border-radius: 6px;
    padding: 20px 0;
  }
  .holder-model {
    position: absolute;
    right: 10px;
    bottom: 40px;
    width: 120px;
    background-color: #cde1fd;
    border-radius: 6px;
    padding: 20px 0;
    .top {
      position: relative;
      height: 100px;
      img {
        cursor: pointer;
      }
      .up {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 0px;
      }
      .left {
        position: absolute;
        left: 20px;
        top: 14px;
      }
      .down {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 54px;
      }
      .right {
        position: absolute;
        right: 20px;
        top: 14px;
      }
    }
    .bottom {
      padding: 0 10px;
      img {
        width: 15px;
        cursor: pointer;
        margin-left: 2px;
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/videoPlay/h5Video/h5Video.vue